import { UserContext, MediaUserSnowplowTracker } from 'hudl-user-tracking';

export default function trackPage(screenTrackingPageName, mediaSnowplowTrackerContext) {
  const {
    isTrackerEnabled,
    userId,
    role,
    backdooredUserId,
    isProduction,
    snowplowCollectorSubdomain,
  } = mediaSnowplowTrackerContext;

  if (!isTrackerEnabled) {
    return;
  }

  const thorTrackerSettings = {
    appId: 'Hudl',
    collectorEndpoint: `${snowplowCollectorSubdomain}.thorhudl.com`,
    cookieDomain: '.thorhudl.com',
    discoverRootDomain: false,
    encodeBase64: true,
    forceSecureTracker: true,
    platform: 'web',
    post: true,
    stateStorageStrategy: 'localStorage',
    userFingerprint: true,
    contexts: {
      webPage: true,
      gaCookies: true,
      geolocation: false,
      performanceTiming: true,
    },
  };

  const prodTrackerSettings = {
    appId: 'Hudl',
    collectorEndpoint: `${snowplowCollectorSubdomain}.hudl.com`,
    cookieDomain: '.hudl.com',
    discoverRootDomain: false,
    encodeBase64: true,
    forceSecureTracker: true,
    platform: 'web',
    post: true,
    stateStorageStrategy: 'localStorage',
    userFingerprint: true,
    contexts: {
      webPage: true,
      gaCookies: false,
      geolocation: false,
      performanceTiming: false,
    },
  };

  const trackerSettings = isProduction
  ? prodTrackerSettings
  : thorTrackerSettings;

  const config = {
    globalSnowplowName: 'hudlSnowplowMediaUserTracker',
    trackerName: 'MediaUserSnowplowTracker',
    trackerSettings: trackerSettings,
    userId: userId,
  };

  const tracker = new MediaUserSnowplowTracker(config);

  const userContext = userId
  ? [new UserContext({
    user_id: userId,
    role: role,
    backdoored_user_id: backdooredUserId,
  })]
  : null;

  tracker.trackPage(screenTrackingPageName, userContext);
}
